import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
});

/* =======================
   REQUEST INTERCEPTOR
======================= */
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

/* =======================
   RESPONSE INTERCEPTOR
======================= */
instance.interceptors.response.use(
  (response) => {
    // Atualiza token se backend enviar um novo
    if (response.headers?.authorization) {
      localStorage.setItem("userToken", response.headers.authorization);
    }

    return response;
  },

  (error) => {
    const { response } = error;

    // ❌ Sem resposta do servidor
    if (!response) {
      return Promise.reject("Erro de conexão com o servidor.");
    }

    const status = response.status;
    const hasNewToken = !!response.headers?.authorization;

    // 🔐 Sessão renovada
    if (status === 401 && hasNewToken) {
      localStorage.setItem("userToken", response.headers.authorization);
      return Promise.reject(response.data);
    }

    // ⛔ Sessão expirada
    if (status === 401 && !hasNewToken) {
      alert("Sua sessão expirou. Faça login novamente.");
      localStorage.removeItem("userToken");
      window.location.href = "/";
      return;
    }

    // 🚫 Sem permissão
    if (status === 403) {
      return Promise.reject(
        "Você não tem permissão para acessar este recurso."
      );
    }

    /* =======================
       TRATAMENTO DE ERRO BLOB
    ======================= */
    if (response.data instanceof Blob) {
      return new Promise((_, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const text = reader.result;
            const json = JSON.parse(text);
            reject(json?.message || text);
          } catch {
            reject(reader.result || "Erro inesperado.");
          }
        };

        reader.onerror = () => {
          reject("Erro ao processar resposta do servidor.");
        };

        reader.readAsText(response.data);
      });
    }

    /* =======================
       NORMALIZAÇÃO DE ERRO
    ======================= */
    let errorMessage = "Erro inesperado.";

    if (typeof response.data === "string") {
      errorMessage = response.data;

    } else if (response.data?.message) {
      errorMessage = response.data.message;

    } else if (Array.isArray(response.data?.errors)) {
      errorMessage = response.data.errors.join(", ");

    } else if (typeof response.data === "object") {
      errorMessage = JSON.stringify(response.data.data) || JSON.stringify(response.data);
    }

    return Promise.reject(errorMessage);
  }
);

export default instance;
